import { Button, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { Dialog } from './Dialog'
import { MiwProgress as MiwProgress } from '../utils/dataFormatting'
import { mainPriorityMainValue, regularTargetValue } from '../utils/constants'

interface ButtonProps {
  level: MiwProgress
  targetNumber: number
  points: number
  backgroundColor: string
  onSubmit: (progress: MiwProgress) => void
  progress: MiwProgress
}

const ProgressButton: React.FC<ButtonProps> = ({level, targetNumber, points, backgroundColor, onSubmit, progress}) => (
  <Button
    variant="contained"
    color="primary"
    fullWidth={true}
    onClick={() => onSubmit(level)}
    style={{
      marginBottom: '8px',
      backgroundColor: backgroundColor,
      border: progress === level ? '2px solid gold' : '2px solid transparent',
    }}
  >
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div>{targetNumber} minutes</div>
      <Typography variant="caption" color="textSecondary">
        {points} points
      </Typography>
    </div>
  </Button>
)


interface Props {
  targetText: string
  progress: MiwProgress
  starterTarget: number
  mainTarget: number
  onSubmit: (progress: MiwProgress) => void
  onClose: () => void
}

export const MiwDialog: React.FC<Props> = ({ targetText, progress, starterTarget, mainTarget, onSubmit, onClose }) => {
  return (
    <Dialog
      title="Most Important Work 🚀"
      hasSubmitButton={false}
      onSubmit={() => onSubmit(progress)}
      onClose={onClose}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{padding: '10px 0'}}>{targetText}</div>
        <ProgressButton
          level={MiwProgress.none}
          targetNumber={0}
          points={0}
          backgroundColor='gray'
          onSubmit={() => onSubmit(MiwProgress.none) }
          progress={progress}
        />
        <ProgressButton
          level={MiwProgress.starter}
          targetNumber={starterTarget}
          points={regularTargetValue}
          backgroundColor='darkkhaki'
          onSubmit={() => onSubmit(MiwProgress.starter) }
          progress={progress}
        />
        <ProgressButton
          level={MiwProgress.main}
          targetNumber={mainTarget}
          points={mainPriorityMainValue}
          backgroundColor='#32cd32'
          onSubmit={() => onSubmit(MiwProgress.main) }
          progress={progress}
        />
      </div>
    </Dialog>
  )
}
